 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-ch-ts":"lang-ch-ts","lang-en-ts":"lang-en-ts"}[chunkId]||chunkId) + "." + {"chunk-08352482":"8b801626","chunk-bb79128e":"d464b217","chunk-f850c056":"15744794","chunk-277250de":"af15af4f","chunk-2d0b28ce":"8b64cbe7","chunk-ae0fe7d0":"227eb1ed","chunk-ae14695a":"098e637b","chunk-0108324c":"fe858bca","chunk-098cd01a":"87feced2","chunk-1483f525":"7e1493d1","chunk-155b8ed4":"e9a82108","chunk-40dbd2a4":"80ca8c6b","chunk-6298a2b0":"3e07f973","chunk-62695668":"f05f5a99","chunk-74696b36":"4fc0e61f","chunk-62b30220":"38787ffe","chunk-63b702b3":"bbee9dda","chunk-644345d5":"3307a9d9","chunk-65747e5f":"ffbc75bf","chunk-75ca39b7":"4f3e14b8","chunk-02ea6752":"893740f0","chunk-22482f7e":"0029455f","chunk-2ea2c7ae":"a19f171f","chunk-7266db81":"36b9c749","chunk-7745d112":"5b1b338c","chunk-afcd6caa":"8d3cb007","chunk-c79c8d68":"980d8455","chunk-c083c1b0":"fb75b5a5","chunk-2d0bd205":"6dacc276","chunk-5d410b3a":"e014d8fe","chunk-af3e823a":"a9a74058","chunk-2604d618":"2046f37b","chunk-eba09d4e":"ebc6e651","chunk-f3fd8b46":"d25189c1","chunk-208fad23":"c0d00b87","chunk-4391f028":"97f043fe","chunk-4df06d4c":"60550b6f","chunk-55c42210":"b169f3be","chunk-3ee96628":"c6ee027f","chunk-960c1284":"91e6298c","chunk-af6e95fa":"1382af35","chunk-b529e0fa":"c6752ed4","lang-ch-ts":"d358e62a","lang-en-ts":"7f385d27","chunk-2d0c05f4":"efb9fc0d","chunk-2d0c1929":"e855db1d","chunk-2d0ce74f":"ce6522d3","chunk-2d0dd440":"93799803","chunk-2d0ddc7a":"9c45b03c","chunk-2d0ddd68":"3fdf87ab","chunk-2d0df408":"d46d1e3d","chunk-2d0e2532":"a2960a4c","chunk-2d0e48be":"9f44c729","chunk-2d0e508a":"094c9c69","chunk-2d21060f":"744312ad","chunk-2d22c124":"7d84054d","chunk-33df7966":"4b77e46f","chunk-5f8b5f70":"f3d9d22c","chunk-626fc88c":"84939fc6","chunk-745fee07":"30fd4f13","chunk-0e7d798c":"89b59a28","chunk-5f3bd499":"dfbae0f1","chunk-6d5a2c88":"ca1f1f41","chunk-7f0d7215":"f4ce0337","chunk-83c4785e":"17b229d8","chunk-163909e8":"967c4051","chunk-60ef1655":"8f2ca726","chunk-7a3faf6b":"d9a8b835","chunk-96860586":"4bc9345c","chunk-df0a5ed2":"3181480b","chunk-96b8201e":"9971acfc","chunk-2d217a0d":"aa6cc8d3","chunk-beb34dce":"21cf2bf8","chunk-2d0a3ffb":"fa488dc8","chunk-31f11ff2":"fcfd90e1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-08352482":1,"chunk-f850c056":1,"chunk-277250de":1,"chunk-ae0fe7d0":1,"chunk-ae14695a":1,"chunk-0108324c":1,"chunk-098cd01a":1,"chunk-1483f525":1,"chunk-155b8ed4":1,"chunk-40dbd2a4":1,"chunk-6298a2b0":1,"chunk-62b30220":1,"chunk-63b702b3":1,"chunk-644345d5":1,"chunk-65747e5f":1,"chunk-75ca39b7":1,"chunk-02ea6752":1,"chunk-22482f7e":1,"chunk-2ea2c7ae":1,"chunk-7266db81":1,"chunk-7745d112":1,"chunk-afcd6caa":1,"chunk-c79c8d68":1,"chunk-c083c1b0":1,"chunk-5d410b3a":1,"chunk-2604d618":1,"chunk-eba09d4e":1,"chunk-f3fd8b46":1,"chunk-208fad23":1,"chunk-4391f028":1,"chunk-4df06d4c":1,"chunk-55c42210":1,"chunk-3ee96628":1,"chunk-960c1284":1,"chunk-af6e95fa":1,"chunk-b529e0fa":1,"chunk-33df7966":1,"chunk-626fc88c":1,"chunk-0e7d798c":1,"chunk-5f3bd499":1,"chunk-6d5a2c88":1,"chunk-7f0d7215":1,"chunk-83c4785e":1,"chunk-163909e8":1,"chunk-60ef1655":1,"chunk-7a3faf6b":1,"chunk-96860586":1,"chunk-df0a5ed2":1,"chunk-96b8201e":1,"chunk-beb34dce":1,"chunk-31f11ff2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-ch-ts":"lang-ch-ts","lang-en-ts":"lang-en-ts"}[chunkId]||chunkId) + "." + {"chunk-08352482":"a5057da8","chunk-bb79128e":"31d6cfe0","chunk-f850c056":"a41e168d","chunk-277250de":"3363fb7e","chunk-2d0b28ce":"31d6cfe0","chunk-ae0fe7d0":"cddf5c74","chunk-ae14695a":"cddf5c74","chunk-0108324c":"fbe2b64d","chunk-098cd01a":"dfc74237","chunk-1483f525":"dfc74237","chunk-155b8ed4":"dfc74237","chunk-40dbd2a4":"722936d9","chunk-6298a2b0":"dfc74237","chunk-62695668":"31d6cfe0","chunk-74696b36":"31d6cfe0","chunk-62b30220":"dfc74237","chunk-63b702b3":"dfc74237","chunk-644345d5":"dfc74237","chunk-65747e5f":"dfc74237","chunk-75ca39b7":"2efee817","chunk-02ea6752":"3f2fa39d","chunk-22482f7e":"3d2ed471","chunk-2ea2c7ae":"cc34d084","chunk-7266db81":"a27fa2c8","chunk-7745d112":"7ed6e53a","chunk-afcd6caa":"3267c487","chunk-c79c8d68":"ceb713f5","chunk-c083c1b0":"001396d5","chunk-2d0bd205":"31d6cfe0","chunk-5d410b3a":"02342c2f","chunk-af3e823a":"31d6cfe0","chunk-2604d618":"b126d368","chunk-eba09d4e":"dfc74237","chunk-f3fd8b46":"dfc74237","chunk-208fad23":"c8f20b7f","chunk-4391f028":"dfc74237","chunk-4df06d4c":"dfc74237","chunk-55c42210":"dfc74237","chunk-3ee96628":"15a8ccc9","chunk-960c1284":"dfc74237","chunk-af6e95fa":"c53fab3c","chunk-b529e0fa":"c53fab3c","lang-ch-ts":"31d6cfe0","lang-en-ts":"31d6cfe0","chunk-2d0c05f4":"31d6cfe0","chunk-2d0c1929":"31d6cfe0","chunk-2d0ce74f":"31d6cfe0","chunk-2d0dd440":"31d6cfe0","chunk-2d0ddc7a":"31d6cfe0","chunk-2d0ddd68":"31d6cfe0","chunk-2d0df408":"31d6cfe0","chunk-2d0e2532":"31d6cfe0","chunk-2d0e48be":"31d6cfe0","chunk-2d0e508a":"31d6cfe0","chunk-2d21060f":"31d6cfe0","chunk-2d22c124":"31d6cfe0","chunk-33df7966":"b7e08bb6","chunk-5f8b5f70":"31d6cfe0","chunk-626fc88c":"d9ef5cb2","chunk-745fee07":"31d6cfe0","chunk-0e7d798c":"35e9df35","chunk-5f3bd499":"251be634","chunk-6d5a2c88":"ca1f0fd2","chunk-7f0d7215":"5725dfc1","chunk-83c4785e":"895104ae","chunk-163909e8":"ac035fbc","chunk-60ef1655":"187750e1","chunk-7a3faf6b":"fd225527","chunk-96860586":"39352761","chunk-df0a5ed2":"217b24ef","chunk-96b8201e":"d78a4574","chunk-2d217a0d":"31d6cfe0","chunk-beb34dce":"f65ac7fb","chunk-2d0a3ffb":"31d6cfe0","chunk-31f11ff2":"f1ab26a3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
